import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { FileProvider } from './file.provider';
import { FileCard } from './file.card/file.card';
import { FileLinker } from './file.linker/file.linker';
import { FileList } from './file.list/file.list';
//import { createCustomElement } from '@angular/elements';
import { CommonModule } from '@angular/common';
import { FileDialog } from './file.list/file.dialog';
import { FileUploadDialog } from './file.upload/file.upload.dialog';
import { FileTreeNode } from './file.tree/file.tree.node';
import { FileSearchbox } from './file.searchbox/file.searchbox';
import { ToolsModule } from '../tools/tools.module';
import { FileTree } from './file.tree/file.tree';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileExplorer } from './file.explorer/file.explorer';
import { FolderDialog } from './file.tree/folder.dialog';
import { ImportMaterialModule } from '../material.module';

import { ElementZoneStrategyFactory } from 'elements-zone-strategy';
import { createCustomElement } from '@angular/elements';
import { FileLinkerUploadDirective } from './file.linker/file.linker.upload.directive';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { Constants } from '../Constants';
import { FileDownloadProgress } from './download.progress/file.download.progress';
import { FileShareDialog } from './file.list/share.dialog';
import { LayoutModule } from '../grid/layout.module';
import { CloudSessionInterceptor, EncryptDecryptAuthInterceptor } from 'ess-plugin-base';




@NgModule({
    declarations: [
        FileCard, FileLinker, FileLinkerUploadDirective,
        FileList, FileDialog, FileUploadDialog,
        FileDownloadProgress, FileShareDialog,
        FileTreeNode, FileTree,
        FileSearchbox, FileExplorer,
        FolderDialog,
    ],
    imports: [
        CommonModule,
        //BrowserModule,
        //BrowserAnimationsModule,
        FormsModule, ReactiveFormsModule,
        // MatCommonModule, MatButtonModule, 
        // MatChipsModule, MatIconModule,
        // MatListModule,
        // MatInputModule, MatFormFieldModule, MatSelectModule, 
        // MatDialogModule,
        // MatProgressBarModule,
        // MatProgressSpinnerModule,
        //, MatCheckboxModule, MatGridListModule,
        LayoutModule, ToolsModule,
        ImportMaterialModule,
    ],
    exports: [
        FileCard, FileLinker, FileLinkerUploadDirective,
        FileList, FileDialog, FileUploadDialog,
        FileDownloadProgress, FileShareDialog,
        FileTreeNode, FileTree,
        FileSearchbox, FileExplorer,
        FolderDialog,
    ],
    providers: [
        FileProvider,
        { provide: HTTP_INTERCEPTORS, useClass: CloudSessionInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: EncryptDecryptAuthInterceptor, multi: true },
    ],
    entryComponents: [
        FileLinker,
        FileList, FileDialog, FileUploadDialog,
        FileShareDialog,
        FileTree, FileSearchbox, FileExplorer,
        FolderDialog,
    ]
})
export class FileModule {

    constructor(private injector: Injector, private http: HttpClient) {

        this.loadSettings(http);

        try {
            if (!customElements.get('ess-file-explorer')) {
                const explorerFactory = new ElementZoneStrategyFactory(FileExplorer, this.injector);

                const explorer = createCustomElement(FileExplorer, { injector: this.injector, strategyFactory: explorerFactory });

                customElements.define('ess-file-explorer', explorer as any);
                console.log("Registered element (with distinct selector!!!!!!) " + "ess-file-explorer");
            }
        } catch (err) { }

        try {
            if (!customElements.get('ess-file-linker')) {
                const linkerFactory = new ElementZoneStrategyFactory(FileLinker, this.injector);

                const linker = createCustomElement(FileLinker, { injector: this.injector, strategyFactory: linkerFactory });

                customElements.define('ess-file-linker', linker as any);
                console.log("Registered element (with distinct selector!!!!!!) " + "ess-file-linker");
            }
        } catch (err) { }
    }

    loadSettings(http: HttpClient) {
        // constructor(private http: HttpClient, private i18n: I18N,
        //     private overlay: OverlayContainer, private injector: Injector) {

        // this.overlay.getContainerElement().classList.add('default');

        this.http.get('assets/settings.json')
            .toPromise()
            .then((settings: any) => {
                if (settings) {
                    Constants.protocol = settings.protocol || Constants.protocol;
                    Constants.identityServer = settings.identityServer || Constants.identityServer;
                    Constants.fileServer = settings.fileServer || Constants.fileServer;
                    Constants.eventServer = settings.eventServer || Constants.eventServer;
                    Constants.max_file_size = settings.max_file_size || Constants.max_file_size;
                    Constants.broadcast();

                    console.log("loaded Settings");
                } else {
                    console.log("No settings returned");
                }
            })
            .catch(err => {
                console.log("Failed to load settings from settings.json");
            });

        //   this.http.get('assets/i18n.json')
        //     .toPromise()
        //     .then((response: any) => {
        //       // console.log("response : ", response);
        //       if (response) {
        //         this.i18n.load(response);
        //         this.i18n.switch(I18N.lang);

        //         // this.i18n_loaded = true;
        //         // return response;
        //       } else {
        //         // console.log('response is null ');
        //         // return null;
        //       }
        //     })
        //     .catch(err => {
        //         console.log("Failed to load translations from i18n.json");
        //     })
    }
}